"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormFacadeSimple", {
    enumerable: true,
    get: function() {
        return FormFacadeSimple;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Option = require("./model/Option");
const _contexts = require("../../../contexts");
const _FormSelectFacade = require("../FormSelect/FormSelectFacade");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormFacadeSimple = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { localValue, options, disabled = false, emptyLabel, className = "" } = param;
    const theme = (0, _contexts.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_FormSelectFacade.FormSelectFacade, {
        disabled: disabled,
        className: className,
        ref: ref
    }, /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, localValue.length > 0 ? /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "836f3eaa8705bcc8",
                [
                    theme.spacers.s3
                ]
            ]
        ]) + " " + "multi"
    }, localValue.map((value)=>{
        const option = options.find((o)=>o.value === value);
        return option == null ? null : /*#__PURE__*/ _react.default.createElement("div", {
            key: option.value,
            className: _style.default.dynamic([
                [
                    "836f3eaa8705bcc8",
                    [
                        theme.spacers.s3
                    ]
                ]
            ])
        }, (0, _Option.optionLabel)(option, true));
    })) : /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, emptyLabel))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "836f3eaa8705bcc8",
        dynamic: [
            theme.spacers.s3
        ]
    }, ".multi.__jsx-style-dynamic-selector div.__jsx-style-dynamic-selector{margin-bottom:".concat(theme.spacers.s3, "}.multi.__jsx-style-dynamic-selector div.__jsx-style-dynamic-selector:last-child{margin-bottom:0}")));
});
FormFacadeSimple.displayName = "FormFacadeSimple";

//# sourceMappingURL=FormFacadeSimple.js.map